import { api } from 'app/config/apiConfig';
import { Zone, CreateZoneParams } from '../model/types';

export const createZoneApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createZone: builder.mutation<Zone, CreateZoneParams>({
      query: ({ warehouseId, ...payload }) => ({
        url: `/warehouses/${warehouseId}/zones`,
        method: 'POST',
        body: { ...payload, warehouseId },
      }),
      invalidatesTags: ['Zones'],
    }),
  }),
});

export const { useCreateZoneMutation } = createZoneApi;
